<template>
  <div class="slot-button" v-on="$listeners" v-bind="$attrs">
    <AppRouterLink class="slot-button__link" :text="text" :to="to">
      <!-- custom content -->
      <div class="slot-button__icon">
        <slot />
      </div>
    </AppRouterLink>
  </div>
</template>

<script>
// Components
import AppRouterLink from 'Ui/AppRouterLink'

export default {
  name: 'SlotButton',

  components: {
    AppRouterLink,
  },
  props: {
    to: {
      type: Object,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.slot-button {
  height: 100%;
}

.slot-button__link {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 180px;
  background: none;
  border: 2px dotted var(--c-secondary-400);
  border-radius: 8px;
  margin: 0;
  outline: none;
  pointer-events: all;
  cursor: pointer;
  text-decoration: none;
  transition: var(--transition--default);
  transform-origin: 51% 51%;
  will-change: transform;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0) scale(1, 1);
  transform: translateZ(0);
}

.slot-button__link:hover {
  transform: scale(1.03);
}

.slot-button__link >>> .app-link__title {
  display: inline-block;
  font-size: 15px;
  line-height: 22px;
  font-weight: 700;
  margin: 0;
  margin-top: 16px;
  color: var(--c-primary);
  pointer-events: none;
}

.slot-button__icon {
  display: inline-block;
  position: relative;
  width: 100%;
  min-height: 40px;
  text-align: center;
  pointer-events: none;
}

.slot-button__icon >>> .app-icon {
  display: inline-block;
  position: absolute;
  left: 0;
  right: 0;
  font-size: 36px;
  line-height: 37px;
  color: var(--c-secondary-500);
  vertical-align: middle;
  transition: 0.6s ease;
}
</style>
